import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 p-6 bg-white"
}
const _hoisted_2 = { class: "font-bold text-black text-medium" }
const _hoisted_3 = { class: "flex flex-row flex-row-reverse justify-between mt-20" }
const _hoisted_4 = { class: "w-1/2 text-center" }
const _hoisted_5 = { class: "flex flex-row px-2 text-light text-gray-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_7 = { class: "w-5/12" }
const _hoisted_8 = { class: "w-2/6" }
const _hoisted_9 = { class: "w-1/6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 px-4" }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "reportsCountriesCanvas" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportsCountriesLegendItem = _resolveComponent("ReportsCountriesLegendItem")!

  return (_ctx.state.legend.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("report.parcels_per_country.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("report.parcels_per_country.labels.country")), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("report.parcels_per_country.labels.parcels_number")), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("report.parcels_per_country.labels.percent")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.legend, (item, index) => {
              return (_openBlock(), _createBlock(_component_ReportsCountriesLegendItem, {
                color: item.color,
                countryName: item.countryName,
                parcelsCount: item.parcelsCount,
                parcelsPercentage: item.parcelsPercentage,
                key: `reports_countries_legend_item_${index}`
              }, null, 8, ["color", "countryName", "parcelsCount", "parcelsPercentage"]))
            }), 128))
          ]),
          _hoisted_10
        ])
      ]))
    : _createCommentVNode("", true)
}